import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { Conferences } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${Conferences.Pages.CONFERENCES}`,
    name: Conferences.Pages.CONFERENCES,
    component: () => import(/* webpackChunkName: "conferences" */ './views/Conferences.vue'),
    meta: {
      access_roles: RouteRoles[Conferences.Pages.CONFERENCES],
    },
  },

  {
    path: `/${Conferences.Pages.NEW_CONFERENCE}/:id`,
    name: Conferences.Pages.NEW_CONFERENCE,
    component: () => import(/* webpackChunkName: "conferences" */ './views/NewConference.vue'),
    meta: {
      access_roles: RouteRoles[Conferences.Pages.NEW_CONFERENCE],
    },
  },

  {
    path: `/${Conferences.Pages.EDIT_CONFERENCE}`,
    name: Conferences.Pages.EDIT_CONFERENCE,
    component: () => import(/* webpackChunkName: "conferences" */ './views/NewConference.vue'),
    meta: {
      access_roles: RouteRoles[Conferences.Pages.EDIT_CONFERENCE],
    },
  },

  {
    path: `/${Conferences.Pages.CONFERENCE_DETAIL}/:id`,
    name: Conferences.Pages.CONFERENCE_DETAIL,
    component: () => import(/* webpackChunkName: "conferences" */ './views/ConferenceDetail.vue'),
    meta: {
      access_roles: RouteRoles[Conferences.Pages.CONFERENCE_DETAIL],
    },
  },
];

export default routes;
